// Component types

// export const FUNCTION = 1;
// export const HOST = 2;
// export const CLASS = 3;

// Operation (flag) types
export const NONE = 4;
export const PLACEMENT = 5;
export const UPDATE = 6;
export const DELETION = 7;

// Effect types
export const NOEFFECT = 8;
export const EFFECT = 9;
export const EFFECTONCE = 10;
export const LAYOUT = 11;
export const LAYOUTONCE = 12;

// Elements
export const TEXT_ELEMENT = "_t";
export const NullElement = "_";
export const Space = " ";
export const Empty = "";

export const KeyStr = "key";
export const RefStr = "ref";
export const StyleStr = "style";
export const DotStr = ".";
